export default __webpack_public_path__ + "static/media/MarkPro-Medium.d71f2bef.otf";